import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { Plus, ThreeDotsVertical } from "react-bootstrap-icons";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import ClubPostCompleteModal from "./modals/ClubPostCompleteModal";
import UploadImageToPostModal from "./modals/UploadImageToPostModal";
import DeleteImageModal from "./modals/DeleteImageModal";
import ConfirmChangeProfileClubImage from "./modals/ConfirmChangeProfileClubImage";
import "./CreatePost.css";

export default function CreatePost() {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [clubPostId, setClubPostId] = useState("");
  const [complete, setComplete] = useState(false);

  const [imgActiveModal, setImgActiveModal] = useState(false);

  const [images, setImages] = useState([]);

  const [selectedImageId, setSelectedImageId] = useState(null);
  const [UpdateMainImageModal, setUpdateMainImageModal] = useState(false);

  const [deleteImageModal, setDeleteImageModal] = useState(false);

  const { user } = useAuthContext();

  const handleMakeDefault = async (imageId) => {
    const makeDefaultResponse = await axios.post(
      `${ApiConnectionString}/api/Image/MakeMain/${imageId}`,
      null,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );
  };

  const cancelModal = () => {
    setImgActiveModal(false);
    setDeleteImageModal(false);
    setUpdateMainImageModal(false);
  };

  const fetchData = async () => {
    const imageResponse = await axios.get(
      `${ApiConnectionString}/api/images?ClubPostId=${clubPostId}`
    );
    setImages(imageResponse.data);

    const clubPostResponse = await axios.get(
      `${ApiConnectionString}/api/ClubPostCreateOrContinue/${id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (clubPostResponse.status == 200) {
      setClubPostId(clubPostResponse.data.id);
      if (clubPostResponse.data.title != null) {
        setTitle(clubPostResponse.data.title);
      }
      if (clubPostResponse.data.content != null) {
        setTitle(clubPostResponse.data.content);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [
    deleteImageModal,
    imgActiveModal,
    clubPostId,
    UpdateMainImageModal,
    user,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const post = {
      id: clubPostId,
      ClubId: id,
      title,
      content,
    };

    const clubPoseResposeComplete = await axios.put(
      `${ApiConnectionString}/api/CompleteClubPost`,
      post,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    setComplete(true);
  };

  return (
    <div className="container bg-white">
      <div className="blueBanner">
        <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
          Create A Post
        </p>
      </div>

      <button
        className="profile-blue-button my-2 d-flex"
        onClick={() => setImgActiveModal(true)}
      >
        <Plus className="profile-social-icon" />
        <a className="fw-bold mx-2 mt-1">Add Image</a>
      </button>
      {images.length != 0 && (
        <div className="row">
          {images.map((image) => (
            <div key={image.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
              {image.mainImage && <p>Main Image</p>}
              <div className="position-relative mt-2">
                <img
                  src={`${ApiConnectionString}/api/image/${image.id}`}
                  alt="Club Image"
                  width={200}
                  className="img-fluid"
                />
                <div className="position-absolute top-0 end-0 mt-2 me-2">
                  <Dropdown>
                    <Dropdown.Toggle
                      as="span"
                      id="dropdown-custom-components"
                      className="dropdown-toggle-custom"
                    >
                      <ThreeDotsVertical
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedImageId(image.id)}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => setUpdateMainImageModal(true)}
                      >
                        Make Default
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setDeleteImageModal(true)}>
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <form onSubmit={handleSubmit} className="mt-3">
        <div className="form-group w-50">
          <label className="fw-bold red-text">Title</label>
          <input
            type="text"
            id="title"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group w-50">
          <label className="fw-bold red-text">Content</label>
          <textarea
            id="content"
            className="form-control"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            rows={5}
          />
        </div>

        <button type="submit" className="saveChanges-button my-3">
          Submit
        </button>
      </form>
      {complete && <ClubPostCompleteModal id={id} />}
      {imgActiveModal && (
        <UploadImageToPostModal id={clubPostId} cancelModal={cancelModal} />
      )}
      {deleteImageModal && (
        <DeleteImageModal id={selectedImageId} cancelModal={cancelModal} />
      )}

      {UpdateMainImageModal && (
        <ConfirmChangeProfileClubImage
          cancelModal={cancelModal}
          imageId={selectedImageId}
        />
      )}
    </div>
  );
}
